if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      new IntersectionObserver(
        ((e, t) => {
          e[0].isIntersecting &&
            (t.unobserve(this),
            fetch(this.dataset.url)
              .then((e) => e.text())
              .then((e) => {
                const t = document.createElement("div");
                t.innerHTML = e;
                const n = t.querySelector("product-recommendations");
                n &&
                  n.innerHTML.trim().length &&
                  (this.innerHTML = n.innerHTML),
                  !this.querySelector("slideshow-component") &&
                    this.classList.contains("complementary-products") &&
                    this.remove(),
                  t.querySelector("c") &&
                    this.classList.add("product-recommendations--loaded");
              })
              .catch((e) => {
                console.error(e);
              }));
        }).bind(this),
        { rootMargin: "0px 0px 300px 0px" }
      ).observe(this);
    }
  }
  customElements.define("product-recommendations", ProductRecommendations);
}
